<div *ngIf="loading" class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-10">
    <div class="bg-gray-100 opacity-50 h-screen w-screen absolute"></div>
    <mat-spinner></mat-spinner>
</div>

<div class="bg-gray-100 py-10">
    <div class="p-2 md:p-10" style="width: 90%; max-width: 56rem; margin-left: auto; margin-right: auto;">

        <!-- Sección de olvidaste mi contraseña -->
        <div class="p-6 md:p-10 bg-white shadow-md rounded-3xl">
            <h1 class="text-black font-semibold text-xl md:text-2xl mb-6 text-center">¿Olvidaste tu contraseña?</h1>

            <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()" class="space-y-6">

                <!-- Campo Correo Electrónico -->
                <div>
                    <label for="email" class="block text-gray-700 text-sm font-bold mb-2">Correo electrónico
                        registrado</label>
                    <input id="email" type="email" formControlName="email"
                        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">

                    <!-- Mensajes de Error de Validación -->
                    <div *ngIf="forgotPasswordForm.get('email').invalid && forgotPasswordForm.get('email').touched"
                        class="text-red-500 text-xs mt-2">
                        <div *ngIf="forgotPasswordForm.get('email').errors['required']">
                            El correo electrónico es obligatorio.
                        </div>
                        <div *ngIf="forgotPasswordForm.get('email').errors['email']">
                            Formato de correo electrónico no válido.
                        </div>
                    </div>

                    <!-- Mensaje de Éxito -->
                    <div *ngIf="success" class="text-green-600">
                        Se ha enviado el correo electrónico con éxito.
                    </div>

                    <!-- Mensaje de Error de la API -->
                    <div *ngIf="error" class="text-red-600">
                        Hubo un error al enviar el correo electrónico.
                    </div>
                </div>

                <!-- Botón de envío -->
                <div class="flex justify-end">
                    <button type="submit" formControlName="btnSolicitud" [disabled]="forgotPasswordForm.invalid"
                        class="appearAlpha cursor-pointer bg-primary font-medium rounded-3xl px-8 py-2 text-white flex items-center hover:bg-secondary transition ease-linear text-sm">
                        Enviar Solicitud
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>